import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PhoneBluetoothSpeakerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"phone_bluetooth_speaker"}/>
}
